module.exports = __webpack_public_path__ + "static/media/asymmetrik.3d7809f1.svg";